"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.5.2'] && _();
}
catch (e) { }
